import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { GlobalVariableSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, GlobalVariablesFilterSchema } from "../ea.schema.query";

const base = "global-variables";
const gv = createEndpointBase(base);

export const globalVariablesEndpoints = {
  globalVariablesGet: gv({
    method: "GET",
    path: "",
    request: z.object({ filter: GlobalVariablesFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(GlobalVariableSchemas.general),
    description: "Retrieves a list of global variables with filtering support.",
  }),
  globalVariablesCount: gv({
    method: "GET",
    path: "count",
    request: z
      .object({ filter: GlobalVariablesFilterSchema.pick({ where: true }).optional() })
      .optional(),
    response: CountResponseSchema,
    description: "Returns the total number of global variables matching the filters.",
  }),
  globalVariablesCreate: gv({
    method: "POST",
    path: "",
    request: GlobalVariableSchemas["createData"],
    response: GlobalVariableSchemas["general"],
    description: "Creates a new global variable.",
  }),
  globalVariablesUpdate: gv({
    method: "PATCH",
    path: ":id",
    request: GlobalVariableSchemas["update"],
    response: GlobalVariableSchemas["general"],
    description: "Updates an existing global variable.",
  }),
  globalVariablesDelete: gv({
    method: "DELETE",
    path: ":id",
    request: GlobalVariableSchemas["general"].pick({ id: true }),
    response: z.any(),
    description: "Permanently deletes a global variable.",
  }),
  globalVariablesAssignMany: gv({
    method: "POST",
    path: "assignMany",
    request: z.object({ globalVariableId: z.number(), scriptsIds: z.array(z.number()) }),
    response: z.any(),
    description: "Assigns a global variable to multiple scripts.",
  }),
  globalVariablesUnassignMany: gv({
    method: "POST",
    path: "unassignMany",
    request: z.object({ globalVariableId: z.number(), scriptsIds: z.array(z.number()) }),
    response: z.any(),
    description: "Unassigns a global variable from multiple scripts.",
  }),
} as const;
